module.exports = __webpack_public_path__ + "static/img/img-crop1.f7bb1a61.png";